<template>
  <p>
    <a href="/contact/">
      会員についてのお問い合わせはこちら
    </a>
  </p>
</template>

<script>
export default {
  name: 'WithdrawMailer',
};
</script>

<!-- Add 'scoped' attribute to limit CSS to this component only -->
<style scoped lang="scss"></style>
